module.exports = __webpack_public_path__ + "img/sezione_odontoiatria.2ce46506.jpg";